import { Flex, FlexProps } from "@chakra-ui/react";
import { FC, PropsWithChildren } from "react";

const DashboardInfoCard: FC<PropsWithChildren<FlexProps>> = ({
    children,
    ...props
}) => {
    return (
        <Flex
            flex={2}
            flexDir="column"
            w="100%"
            bg="white"
            rounded="lg"
            align="start"
            bgColor="black"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="xl"
            padding={2}
            {...props}
        >
            {children}
        </Flex>
    );
};

export default DashboardInfoCard;
